import { makeAutoObservable } from 'mobx';
import SpecificActivityStore from '../../../stores/SpecificActivityStore';
import {
    ActivityComponentStore,
    ActivityMapComponentStore,
    ActivityChartComponentStore,
    ActivityHeatmapComponentStore,
} from '../../../stores/insights/InsightsComponentStore';

export enum E_COMPONENT_TYPE_TO_DISPLAY {
    MAP,
    CHART,
    HEATMAP
}
class InsightsStore {
    public activeID: string;
    public isEditing: boolean = false;
    public isResizing: boolean = false;
    public activity: SpecificActivityStore;
    public isEditingComponent: boolean = false;
    public annotationMode: boolean = false;
    private mapComponent: ActivityMapComponentStore = null;
    private chartComponent: ActivityChartComponentStore = null;
    private heatmapComponent: ActivityHeatmapComponentStore = null;
    private componentTypeToDisplay: E_COMPONENT_TYPE_TO_DISPLAY;


    constructor() {
        makeAutoObservable(this);
    }
    public setActivity(activity: SpecificActivityStore) {
        this.activity = activity;
    }

    public setComponentTypeToDisplay(
        type: E_COMPONENT_TYPE_TO_DISPLAY
    ) {
        if (this.componentTypeToDisplay !== type) {
            this.componentTypeToDisplay = type;
        }
    }
    public setAnnotatingMode(state: boolean) {
        this.activeID = null;
        this.isEditing = false;
        this.annotationMode = state;
    }

    public setEditing(id: string) {
        this.isEditing = !!id;
        this.activeID = id;
    }
    public setActive(id: string) {
        this.activeID = id;
    }
    public setResizing(val: boolean) {
        this.isResizing = val;
    }
    public prepareForPrint() {
        this.isEditing = false;
        this.activeID = null;
    }
    public setDisplayedComponent(
        map: ActivityMapComponentStore,
        chart: ActivityChartComponentStore,
        heatmap: ActivityHeatmapComponentStore
    ) {
        this.mapComponent = map;
        this.chartComponent = chart;
        this.heatmapComponent = heatmap;
    }

    public setEditingComponent(
        map: ActivityMapComponentStore,
        chart: ActivityChartComponentStore,
        heatmap: ActivityHeatmapComponentStore
    ) {
        this.isEditingComponent = true;
        this.setDisplayedComponent(map, chart, heatmap);
    }

    public restoreEditingComponent() {
        this.isEditingComponent = false;
    }

    public get displayedComponent(): ActivityComponentStore {
        switch(this.componentTypeToDisplay){
            case E_COMPONENT_TYPE_TO_DISPLAY.CHART:
                return this.chartComponent;
            case E_COMPONENT_TYPE_TO_DISPLAY.MAP:
                return this.mapComponent;
            case E_COMPONENT_TYPE_TO_DISPLAY.HEATMAP:
                return this.heatmapComponent;
            default: return null
        }
    }
}

const store = new InsightsStore();
export default store;
